<template>
    <div class="header-main">
        <top-nav />
        <div class="header-left">
            <div class="logo-wrap">
                <router-link to="/dashboard">
                    <img :src="'/static/kipaki-icon.svg'" alt="logo" class="logo-default" />
                    <span class="logo-name">{{$t('kipaki portal')}}</span>
                </router-link>
            </div>
        </div>
        <div class="header-right">
            <el-col :md="18" :lg="9" class="userinfo">
                <el-dropdown trigger="click" @command="handleRoutes">
                    <span class="el-dropdown-link userinfo-inner">
                        <div class="profile-img">
                            <img :src="user_avatar" alt="admin-photo" />
                        </div>
                        <span class="user-name">{{
                            $store.state.config.user.display_name }}</span>
                        <i class="el-icon-caret-bottom"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="/my-profile">
                            <i class="icon-my-account"></i> {{ $t('My Profile') }}
                        </el-dropdown-item>
                        <el-dropdown-item command="/file-manager">
                            <i class="el-icon-document" style="font-weight:bold"></i> {{ $t('My Files') }}
                        </el-dropdown-item>
                        <el-dropdown-item command="/change-password">
                            <i class="icon-change-password"></i> {{ $t('Change Password') }}
                        </el-dropdown-item>
                        <el-dropdown-item command="/general-settings" v-if="$store.state.config.user.role_slug == 'main-admin'">
                            <i class="icon-settings-work-tool"></i> {{ $t('Settings') }}
                        </el-dropdown-item>
                        <el-dropdown-item @click.native="logout" command="/login">
                            <a class="loguot" href="javascript:void(0)" @click="logout">
                                <i class="icon-logout"></i> {{$t('Logout')}}
                            </a>
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </el-col>
            <el-dropdown class="notification" trigger="click" @visible-change="getAllNotifications">
                <el-badge class="item" :value="notification_count" :hidden="notification_count == 0">
                    <span class="el-dropdown-link">
                        <i class="el-icon-bell" type="primary"></i>
                    </span>
                </el-badge>
                <el-dropdown-menu slot="dropdown" class="notify-drop">
                    <div class="main-title">{{ $t('You have messages',{'0': notifications.meta.total}) }}</div>
                    <div class="all-notifi">
                        <el-dropdown-item v-for="(notif,key,index) in notifications.data" :key="index" :class="(notif.is_read == 0)?'unread':''">
                            <router-link class="noti-left" :to="notif.notification_link">
                                <p class="details">{{notif.notification_message}}</p>
                                <span v-date-time-format="notif.created_at"></span>
                            </router-link>
                            <a href="javascript:void(0)" class="noti-right" @click.stop="removeNotification(notif)">
                                <i class="el-icon-circle-close"></i>
                            </a>
                        </el-dropdown-item>
                    </div>
                    <el-dropdown-item class="view-all" v-if="notifications.meta.total > 0">
                        <router-link to="/notifications">{{ $t('View all') }} <i class="el-icon-d-arrow-right" type="primary"></i></router-link>
                    </el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
            <el-dropdown trigger="click" class='international lang-box' @command="handleSetLanguage">
                <div>
                    {{ language | uppercase }}<i class="el-icon-caret-bottom"></i>
                </div>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-for="langItem in languages" :key="langItem.lang" :command="langItem.lang" :disabled="language===langItem.lang">{{ langItem.Text }}</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
    </div>
</template>

<script>
    import helper from "@/services/helper";
    import Tinycon from 'tinycon'
    import moment from "moment";
    import TopNav from "../TopNav/TopNav";
    export default {
        components: {
            TopNav
        },
        data() {
            return {
                language: process.env.KIPAKI_locale,
                languages: process.env.KIPAKI_languages,
                isActive: this.$store.state.hamBurgur,
                generalSettings: this.$store.state.config.generalSettings,
                activeIndex: '1',
                menuItems: [],
                socket: null,
                notification_count: 0,
                notifications: {
                    meta: {},
                    data: {}
                },
                clickCount: 0
            };
        },
        computed: {
            logo_src() {
                return this.$store.state.config.generalSettings.logo_src;
            },
            user_avatar() {
                return this.$store.state.config.user.profile_image || '/static/default_user.svg';
            }
        },
        mounted() {
            this.language = this.generalSettings.language_id || process.env.KIPAKI_locale;
            serverBus.$on("menuItems", response => {
                this.getMenu();
            });
            Tinycon.setOptions({
                width: 7,
                height: 15,
                font: '10px arial',
                color: '#ffffff',
                background: '#f00',
                fallback: true
            })
            this.socket = io(process.env.KIPAKI_SOCKET_URL, {
                reconnectionAttempts: 1,
            });
            this.socket.on(`user_notification_${this.$store.state.config.user.id}:App\\Events\\UserNotificationAdded`,
                data => {
                    this.notification_count = this.notification_count + 1;
                    Tinycon.setBubble(this.notification_count);
                });
            request({
                    url: "count-user-notifications",
                    method: "get"
                })
                .then(response => {
                    this.notification_count = response.data.data.notification_count;
                    if (this.notification_count > 0) {
                        Tinycon.setBubble(this.notification_count);
                    }
                })
                .catch(error => {
                    console.log(error);
                });
        },
        methods: {
            removeNotification(row) {
                request({
                        url: "user-notifications/" + row.id,
                        method: "delete"
                    }).then(response => {
                        this.getAllNotifications(true);
                    })
                    .catch(error => {
                        console.log(error);
                    });
            },
            getAllNotifications(x) {
                if (x)
                    request({
                        url: "user-notifications",
                        method: "get"
                    })
                    .then(response => {
                        this.notifications = response.data;
                        console.clear()
                        console.log('Notification', this.notifications)
                        this.notification_count = 0;
                        Tinycon.setBubble(null);
                    })
                    .catch(error => {
                        console.log(error);
                    });
            },
            relativeTime(dateTime) {
                return moment(dateTime).fromNow();
            },
            logout() {
                helper.logout().then(() => {
                    this.$router.replace("/login");
                });
            },
            handleSetLanguage(lang) {
                this.language = lang;
                this.generalSettings.language_id = lang;
                this.$store.dispatch("setConfig", {
                    generalSettings: this.generalSettings
                });
                localStorage.setItem("lang", lang);
                location.reload();
            },
            hamburger: function () {
                this.isActive = !this.isActive;
                this.$store.commit("updateHamBurger", this.isActive);
            },
            handleRoutes(url) {
                this.$router.push(url);
            },
            getMenu() {
                request({
                        url: "get-menu",
                        method: "get",
                        params: {}
                    })
                    .then(response => {
                        this.menuItems = (response) ? response.data.data : {};
                        this.$store.dispatch("setConfig", {
                            menuItems: this.menuItems
                        });
                    })
                    .catch(error => {
                        console.log(error);
                    });
            }
        },
        filters: {
            uppercase: function (value) {
                return value.toUpperCase() || "";
            }
        }
    };

</script>

<style>
    .notification {
        float: right;
        padding: 10px 10px 4px 10px;
        border-left: 1px solid #f3f3f3;
    }

    .el-dropdown-menu.notify-drop {
        width: 350px
    }

    @media only screen and (max-width: 320px) {
        .el-dropdown-menu.notify-drop {
            width: 300px;
        }
    }

</style>
<style lang="scss">
    @import "../../../assets/sass/_header.scss";

</style>



// WEBPACK FOOTER //
// src/components/Layout/NavHeader/NavHeader.vue